import {BaseComponent} from '../base.component';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Message} from '../../model/message';
import {ApplicationConfig} from '../../../../config/application.config';

@Component({
  selector: 'app-message-list-item',
  templateUrl: './message-list-item.component.html',
  styleUrls: ['./message-list-item.component.scss'],
})
export class MessageListItemComponent extends BaseComponent {

  @Input() model: Message;
  @Output() clicked: EventEmitter<Message> = new EventEmitter<Message>();

  constructor(public applicationConfig: ApplicationConfig) {
    super();
  }

  public onClick() {
    this.clicked.emit(this.model);
  }
}
